export function HowItWorks() {
  return (
    <section className="infographic-section w-full py-12 md:py-24 lg:py-32 bg-muted dark:bg-gray-800">
      <div className="container px-4 md:px-6 mx-auto">
        <h2 className="section-title text-3xl font-bold tracking-tighter md:text-4xl/tight text-center mb-10 dark:text-white">
          How It Works
        </h2>

        <div className="infographic-steps grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="step-card bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 transition-transform duration-300 hover:translate-y-[-5px]">
            <div className="step-number bg-emerald-600 dark:bg-emerald-500 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg mb-4">
              1
            </div>
            <div className="step-title text-lg font-semibold mb-2 dark:text-white">
              Companies Create an Account
            </div>
            <div className="step-description text-gray-600 dark:text-gray-300">
              Sign up and set up your admin dashboard.
            </div>
          </div>

          <div className="step-card bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 transition-transform duration-300 hover:translate-y-[-5px]">
            <div className="step-number bg-emerald-600 dark:bg-emerald-500 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg mb-4">
              2
            </div>
            <div className="step-title text-lg font-semibold mb-2 dark:text-white">
              Add Workers, Site Locations & Work Hours
            </div>
            <div className="step-description text-gray-600 dark:text-gray-300">
              Mark job site GPS locations and define working hours.
            </div>
          </div>

          <div className="step-card bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 transition-transform duration-300 hover:translate-y-[-5px]">
            <div className="step-number bg-emerald-600 dark:bg-emerald-500 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg mb-4">
              3
            </div>
            <div className="step-title text-lg font-semibold mb-2 dark:text-white">
              Workers Check In/Out Using Their Phones
            </div>
            <div className="step-description text-gray-600 dark:text-gray-300">
              Workers verify Check In and Check out via secure digital protocols and GPS tracking By tapping a button. 
            </div>
          </div>

          <div className="step-card bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 transition-transform duration-300 hover:translate-y-[-5px]">
            <div className="step-number bg-emerald-600 dark:bg-emerald-500 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg mb-4">
              4
            </div>
            <div className="step-title text-lg font-semibold mb-2 dark:text-white">
              Real-Time Attendance Monitoring
            </div>
            <div className="step-description text-gray-600 dark:text-gray-300">
              Company admins view who checked in, when, and where instantly.
            </div>
          </div>

          <div className="step-card bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 transition-transform duration-300 hover:translate-y-[-5px]">
            <div className="step-number bg-emerald-600 dark:bg-emerald-500 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg mb-4">
              5
            </div>
            <div className="step-title text-lg font-semibold mb-2 dark:text-white">
              Late Arrivals Automatically Highlighted
            </div>
            <div className="step-description text-gray-600 dark:text-gray-300">
              The system marks late check-ins for admin review (no blocking the
              check-in).
            </div>
          </div>

          <div className="step-card bg-white dark:bg-gray-900 rounded-xl shadow-md p-6 transition-transform duration-300 hover:translate-y-[-5px]">
            <div className="step-number bg-emerald-600 dark:bg-emerald-500 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg mb-4">
              6
            </div>
            <div className="step-title text-lg font-semibold mb-2 dark:text-white">
              Daily Reports & Attendance History
            </div>
            <div className="step-description text-gray-600 dark:text-gray-300">
              View detailed logs, download reports, and track attendance over
              time.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
